import React from 'react';

export type ChatBubbleProps = {
  children: React.ReactNode;
  className?: string;
  chatBubbleClassName?: string;
  showArrow?: boolean;
};

const ChatBubble = ({
  children,
  className = '',
  chatBubbleClassName = '',
  showArrow = false,
}: ChatBubbleProps) => (
  <div className={`w-full flex flex-col ${className}`}>
    <div
      className={`bg-neutral-100 rounded-md text-sm w-full p-5 text-left whitespace-normal ${chatBubbleClassName}`}
    >
      {children}
    </div>
    {showArrow && (
      <span className='border-x-8 border-solid border-t-[10px] border-x-transparent border-b-transparent border-t-neutral-50 h-px w-px self-center' />
    )}
  </div>
);

export default ChatBubble;
